import _Card from './Card';

import './style/index.js';

export type { CardProps } from './Card';

export const Card = _Card;

export default Card;
